export default __webpack_public_path__ + "static/media/style.f3ae8ce8.less";